import type { DsdEditorCorrectionItem } from "@/utils/dsd-editor/spellcheck";
import { useCallback, useState } from "react";

type CellScrollRequest = {
  cellId: string;
  requestKey: number;
  align?: number;
  reserveBelowPx?: number;
};

type ChunkScrollRequest = {
  chunkId: string;
  requestKey: number;
};

type CorrectionScrollRequest = {
  item: DsdEditorCorrectionItem;
  requestKey: number;
};

export const useDsdEditorReviewScrollRequests = () => {
  const [cellScrollRequest, setCellScrollRequest] =
    useState<CellScrollRequest | null>(null);
  const [chunkScrollRequest, setChunkScrollRequest] =
    useState<ChunkScrollRequest | null>(null);
  const [correctionScrollRequest, setCorrectionScrollRequest] =
    useState<CorrectionScrollRequest | null>(null);

  const requestCellScroll = useCallback(
    (cellId: string, align?: number, reserveBelowPx?: number) => {
      setCellScrollRequest((prev) => ({
        cellId,
        requestKey: (prev?.requestKey ?? 0) + 1,
        align,
        reserveBelowPx,
      }));
    },
    [],
  );

  const requestChunkScroll = useCallback((chunkId: string) => {
    setChunkScrollRequest((prev) => ({
      chunkId,
      requestKey: (prev?.requestKey ?? 0) + 1,
    }));
  }, []);

  const requestCorrectionScroll = useCallback(
    (item: DsdEditorCorrectionItem) => {
      setCorrectionScrollRequest((prev) => ({
        item,
        requestKey: (prev?.requestKey ?? 0) + 1,
      }));
    },
    [],
  );

  return {
    requestCellScroll,
    requestChunkScroll,
    requestCorrectionScroll,
    scrollRequest: {
      chunk: {
        chunkId: chunkScrollRequest?.chunkId ?? null,
        requestKey: chunkScrollRequest?.requestKey ?? 0,
      },
      cell: {
        cellId: cellScrollRequest?.cellId ?? null,
        requestKey: cellScrollRequest?.requestKey ?? 0,
        align: cellScrollRequest?.align,
        reserveBelowPx: cellScrollRequest?.reserveBelowPx,
      },
      correction: {
        item: correctionScrollRequest?.item ?? null,
        requestKey: correctionScrollRequest?.requestKey ?? 0,
      },
    },
  };
};
